var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueNotifications',{attrs:{"position":"top right"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var item = ref.item;
var close = ref.close;
return [_c('NotificationsToast',{attrs:{"data":item},nativeOn:{"click":function($event){return close.apply(null, arguments)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }